module.exports = __webpack_public_path__ + "static/media/hero-unlock.352dde04.jpg";